module.exports = __webpack_public_path__ + "img/rule.48db6773.png";